module.exports = __webpack_public_path__ + "media/images/application/icons/icon-octopus-6aea40a7c15f4547a11a93f16078f1d0.svg";